import { useTranslation } from 'react-i18next'
import { Link, useParams } from 'react-router'

import { Avatar } from 'js/components/Avatar'
import { H1 } from 'js/components/Heading'
import ItemActions from 'js/components/Item/ItemActions/ItemActions'
import ItemStatusTag from 'js/components/Item/ItemStatusTag'
import Text from 'js/components/Text/Text'

import getRefetchQueries from '../helpers/getRefetchQueries'
import PodcastLinks from '../helpers/podcastRoutes'

import styles from './PodcastMenu.module.css'

const PodcastMenu = ({
    title,
    entity,
    icon,
    isEpisode,
    onEdit,
    canCreate = false,
}) => {
    const { owner, authors, showOwner } = entity

    // Detail view, so both the podcast and episode queries need refetching
    const refetchQueries = getRefetchQueries(true, !!entity.group)
    const { t } = useTranslation()
    const params = useParams()

    const authorName = () => {
        const listNames = isEpisode ? entity?.podcast?.authors : authors

        return listNames?.map((name) => name.name).join(', ')
    }

    const renderedAuthorName = authorName()

    const onAfterDelete = isEpisode
        ? entity.podcast.url
        : PodcastLinks.Home(params)

    const customItemOptions =
        !isEpisode && canCreate
            ? [
                  {
                      label: t('entity-podcast.episode.create'),
                      canCreate,
                      url: PodcastLinks.PodcastEpisodeAdd(params.guid, params),
                  },
              ]
            : []

    return (
        <div className={styles.wrapperMenu}>
            {!!icon && (
                <Avatar
                    size="xxlarge"
                    radiusStyle="square"
                    disabled
                    image={icon?.download}
                />
            )}
            <div className={styles.wrapperMenuContent}>
                <H1>{title}</H1>
                {isEpisode ? (
                    <Text size="small">
                        <Link to={entity.podcast.url}>
                            {entity.podcast.title}
                        </Link>
                    </Text>
                ) : (
                    showOwner && (
                        <Text size="small" variant="grey">
                            {renderedAuthorName || (
                                <Link to={owner.url}>{owner.name}</Link>
                            )}
                        </Text>
                    )
                )}
                <ItemStatusTag entity={entity} />
            </div>

            <ItemActions
                showEditButton
                entity={entity}
                onEdit={onEdit}
                onAfterDelete={onAfterDelete}
                refetchQueries={refetchQueries}
                customOptions={[customItemOptions]}
                style={{ marginLeft: 'auto' }}
            />
        </div>
    )
}

export default PodcastMenu
